import React, { useContext } from 'react'
import { HeaderContext } from './HeaderContext'
import SanityLink from '@/lib/SanityLink'
import LinkGroup from './LinkGroup'
import clsx from 'clsx'
import * as css from './PrimaryNav.module.css'

const PrimaryNav = ({ nav }) => {
	const { $open } = useContext(HeaderContext)

	return (
		<nav className={clsx(css.root, !$open && '<md:!hidden')}>
			{nav?.map(({ _type, ...link }, key) => {
				switch(_type) {
					case 'link': return <SanityLink className="py-4 px-6 <md:py-2 text-center" {...link} key={key} />
					case 'linkGroup': return <LinkGroup {...link} key={key} />
					default: return null
				}
			})}
		</nav>
	)
}

export default PrimaryNav
